<template>
    <li>
        <div class="div-item" :style="dynamicPaddingLeft(folder.level)"
            :class="{ active: selectedFolder === folder.url }"
            @click.stop="handleClickFolder"
        >
            <div class="icon-wrapper">
                <v-icon v-if="hasChildren"
                    class="toggle-icon"
                    @click.stop="handleClickFolder"
                >
                    <!-- {{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }} -->
                      {{ 'mdi-folder' }}
                </v-icon>
                <v-icon v-else class="placeholder-icon">mdi-folder</v-icon>
            </div>
            <v-tooltip top>
                <span class="folder-label">{{ formatDateString(folder.label) }}</span>
                <template v-slot:activator="{ on }">
                    <span class="folder-label"
                        v-on="on">{{ folder.label ? formatDateString(folder.label).slice(0, 12) : "" }}{{ formatDateString(folder.label) && formatDateString(folder.label).length > 12 ? "..." : "" }}</span>
                    </template>
            </v-tooltip>
        </div>
        <ul v-if="hasChildren && isOpen">
                <tree-folder
                class="children"
                v-for="child in folder.listData"
                :key="child.url"
                :folder="child"
                :selected-folder="selectedFolder"
                @select-folder="$emit('select-folder', $event)"
            />
        </ul>
    </li>
</template>
  
<script>
  export default {
    name: "TreeFolder",
    props: {
      folder: {
        type: Object,
        required: true,
      },
      selectedFolder: {
        type: String,
        required: true,
      },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        hasChildren() {
            return this.folder.listData && this.folder.listData.length > 0;
        },
    },
    watch: {
        selectedFolder(newVal) {
            if (newVal === this.folder.url) {
                this.isOpen = true;
            }
        },
    },
    mounted() {
        if (this.selectedFolder === this.folder.url) {
            this.isOpen = true;
        }
    },
    methods: {
        toggleFolder() {
            if (this.hasChildren) {
                this.isOpen = !this.isOpen;
            }
        },
        selectThisFolder() {
            this.$emit("select-folder", this.folder);
        },
        dynamicPaddingLeft(level){ 
            return { paddingLeft: `calc(10px + ${level * 15}px)` }
        },
        formatDateString(input){
            if (/^\d{8}$/.test(input)) {
                const year = input.substring(0, 4);
                const month = input.substring(4, 6);
                const day = input.substring(6, 8);
                const date = new Date(`${year}-${month}-${day}`);
                if (!isNaN(date.getTime())) {
                    if (this.$i18n.locale === "en") {
                        return `${year}/${month}/${day}`;
                    } else {
                        return new Intl.DateTimeFormat("ja-JP", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        }).format(date); 
                    }
                }
            }
            return input; 
        },
        handleClickFolder() {
            this.selectThisFolder();
            if (this.hasChildren) {
                this.toggleFolder();
            }
        },
    },
  };
</script>
  
<style scoped>
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        white-space: nowrap; 
    }
    li {
        list-style: none;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #000000;
    }
    .active {
        background: #A8A8A8 !important;
        /* text-decoration: underline; */
    }
    .div-item {
        font-size: 14px;
        padding: 10px
    }
    ul li > div:hover {
        background: #A8A8A8;
        cursor: pointer;
    }
    ul li {
        cursor: default;
        transition: background 0.3s;
    }
    .icon{
        padding: 0px !important;
    }
    .icon-wrapper {
        width: 24px;
        display: inline-block;
        text-align: center;
    }
    .toggle-icon {
        font-size: 16px;
        line-height: 16px;
        vertical-align: middle;
        color: rgb(50, 130, 200) !important;
    }
    .placeholder-icon {
        font-size: 16px;
        line-height: 16px;
        vertical-align: middle;
        color: rgb(50, 130, 200) !important;
    }
    .folder-label {
        vertical-align: middle;
    }
    @media (max-width: 545px) {
        .div-item{
            font-size: 12px !important;
        }
        .placeholder-icon{
            font-size: 14px !important;
        }
        .toggle-icon{
            font-size: 14px !important;
        }
    }
    @media (max-width: 375px) {
        .div-item{
            font-size: 10px !important;
        }
        .placeholder-icon{
            font-size: 14px !important;
        }
        .toggle-icon{
            font-size: 14px !important;
        }
    }
</style>
  